import { render, staticRenderFns } from "./startNewPole.vue?vue&type=template&id=668be710&scoped=true"
import script from "./startNewPole.vue?vue&type=script&lang=js"
export * from "./startNewPole.vue?vue&type=script&lang=js"
import style0 from "./startNewPole.vue?vue&type=style&index=0&id=668be710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668be710",
  null
  
)

export default component.exports